import api from "./api";

export const upgradesService = {
  findAllPackages,
  updatePackagesFromArtifactory,
  requestUpgradeCircuit,
  requestUpgradeDevices,
  findAllDeviceUpgrades,
  findAllCircuitUpgradeRules,
  cancelCircuitUpgradeRule,
  editUpgradeRuleForCircuit,
  editUpgradeRuleForDevice,
  getUpgradeLog,
  getDevicesVersions,
  deleteDeviceUpgrade,
  findAllDeviceUpgradeRules,
  deleteDeviceUpgradeRule
};

function findAllPackages() {
  return api.get("/cable-health-broker/v1/upgrades/packages");
}

function updatePackagesFromArtifactory() {
  return api.post("/cable-health-broker/v1/upgrades/update_packages_from_artifactory");
}

function requestUpgradeCircuit(circuitUuid, version) {
  return api.put("/cable-health-broker/v1/upgrades/upgrade_rules/circuit/", {circuit_uuid: circuitUuid, upgrade_package_name: version});
}

function requestUpgradeDevices(device, version) {
  const fullPath = "/cable-health-broker/v1/upgrades/devices";
  return api.post(fullPath, {device_serial: device, target_version: version});
}

function findAllDeviceUpgrades() {
  return api.get("/cable-health-broker/v1/upgrades/devices");
}

function findAllDeviceUpgradeRules() {
  return api.get("/cable-health-broker/v1/upgrades/upgrade_rules/device/");
}

function findAllCircuitUpgradeRules() {
  return api.get("/cable-health-broker/v1/upgrades/upgrade_rules/circuit/");
}

function cancelCircuitUpgradeRule(circuitUuid) {
  return api.delete("/cable-health-broker/v1/upgrades/upgrade_rules/circuit/" + circuitUuid);
}

function editUpgradeRuleForCircuit(circuitToEdit) {
  return api.put("/cable-health-broker/v1/upgrades/upgrade_rules/circuit/", circuitToEdit);
}

function editUpgradeRuleForDevice(deviceToEdit) {
  return api.put("/cable-health-broker/v1/upgrades/upgrade_rules/device/", deviceToEdit);
}

function getUpgradeLog() {
  return api.get("/cable-health-broker/v1/upgrades/log");
}

function getDevicesVersions() {
  return api.get("/cable-health-broker/v1/devices/versions");
}

function deleteDeviceUpgrade(product_serial_num, target_version) {
  return api.delete(`/cable-health-broker/v1/upgrades/devices/${product_serial_num}/target_version/${target_version}`);
}


function deleteDeviceUpgradeRule(product_serial_num) {
  return api.delete(`/cable-health-broker/v1/upgrades/upgrade_rules/device/${product_serial_num}`);
}